// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ATRp","newExpiryDate":"styles_newExpiryDate__3L2xY","footer":"styles_footer__1ebgb"};